import usePagination from '@/hooks/usePagination';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import { BookmarkTypeEnum, OrderEnum } from '@/types/schema';

import { usePinnedItemsQuery } from '../graphql/queries/generated/pinnedItems';

function usePinnedItems({ search }: { search: string }) {
  const { id: userId } = useUserContext();

  const { data, isFetchingMore, fetchMore, isFetching, isLoading } = usePagination(
    usePinnedItemsQuery,
    {
      filters: {
        name: search,
        userIds: [userId],
        types: [BookmarkTypeEnum.KnowledgeBase],
      },
      sort: [
        {
          field: 'createdAt',
          order: OrderEnum.Desc,
        },
      ],
    },
    {
      edgeKey: 'paginatedBookmarks',
      requestPolicy: 'cache-and-network',
      pageSize: -1,
    },
  );

  return {
    pinnedItems: data,
    // pinnedItems: data?.filter((item) => (item?.entity as any)?.name?.length),
    isFetchingMore,
    fetchMore,
    isFetching,
    isLoading,
  };
}

export default usePinnedItems;
